import { registerPlugin } from '@capacitor/core';

import type { BgLocationPermissionPlugin } from './definitions';

const BgLocationPermission = registerPlugin<BgLocationPermissionPlugin>('BgLocationPermission', {
  web: () => import('./web').then((m) => new m.BgLocationPermissionWeb()),
});

export * from './definitions';
export { BgLocationPermission };
